import {getArgs} from './args.js';
import {lazy} from './lazy.js';

export const mac = (... macros) => {
    return (... args) => {

        let coords = args[0];
        let effect  = args[6];
        let _coords = {};
        for (let id in coords) {
            let found = false;
            for (let _macro of macros) {
                _macro = lazy(_macro, ...args);
                _macro = effect.macros.find(
                    x => x.number === _macro);
                if (!_macro) { continue}
                if (_macro.parameters.some(
                    p => p.id === id)) {
                    found = true;
                    break;
                }
            }
            if (found) {
                _coords[id] = coords[id];
            }
        }

        return _coords;
    };
};

